import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import EditIcon from 'assets/images/icons/edit.svg';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: white;
  border: 1px solid #35447d;
  cursor: pointer;
  margin-bottom: 1rem;
  padding: 0 2rem;
  height: 8rem;
  width: 100%;

  .text-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    color: #35447d;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    p, span {
      overflow: hidden;
      text-align: left;
      text-overflow: ellipsis;
    }
    p {
      font-size: 1.5rem;
      margin: 0 0 0.5rem 0;
    }
    span {
      font-size: 1.3rem;
    }
  }
  img { margin-left: auto; }
`;

const Tile = props => (
  <Wrapper onClick={props.onClick}>
    <div className="text-wrapper">
      <p>{props.name}</p>
      <span>{props.date} - {props.description}</span>
    </div>
    {props.showIcon && <img src={EditIcon} alt="Edit" />}
  </Wrapper>
);

Tile.propTypes = {
  date: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  showIcon: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

Tile.defaultProps = {
  onClick: '',
  showIcon: false,
};

export default Tile;



// WEBPACK FOOTER //
// ./src/components/Tile/index.js